import module from 'recursoshumanos/module.js'

const schema = {
  emision: {
    dias: 'number',
    infonavit: 'number',
    numero_segurosocial: 'number',
    salario_diario_integrado: 'number',
    subtotal: 'number',
    fechaMovimiento: 'date',
    total: 'number',
  },
  sua: {
    dias: 'number',
    dias_bimestre: 'number',
    dias_faltas: 'number',
    dias_faltas_bimestre: 'number',
    dias_incapacidad: 'number',
    dias_incapacidad_bimestre: 'number',
    infonavit: 'number',
    rcv: 'number',
    salario_diario_integrado: 'number',
    total: 'number',
  },
}

export class recursoshumanosPagosSuaHistorialService {
  constructor ($http) {
    this.$http = $http
  }

  get (idEmpresa, registroPatronal, periodo, mes, periodicidad) {
    return this.$http.get('/api/recursos_humanos/sua/pagos/historial', {
      params: {id_empresa: idEmpresa, registro_patronal: registroPatronal, periodo, mes, periodicidad},
      schema,
    })

  }
}

module.service('recursoshumanosPagosSuaHistorialService', recursoshumanosPagosSuaHistorialService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/PagosSua/Historial.js